import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NAME, selectAll, selectEntities, selectIds, selectTotal, State } from './evaluation.reducer';

export const selectEvaluationState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectEvaluationState, (state: State) => state.error);

export const getLoaded = createSelector(selectEvaluationState, (state: State) => state.loaded);

export const getAll = createSelector(selectEvaluationState, selectAll);

export const getCount = createSelector(selectEvaluationState, selectTotal);

export const getIds = createSelector(selectEvaluationState, selectIds);

export const getAllEntities = createSelector(selectEvaluationState, selectEntities);

/**
 * returns array of objects in the order of the given ids
 * @example
 * evaluation$: EvaluationInterface[] = this.store.pipe(
    select(EvaluationQueries.getByIds, { ids: [2, 1, 3] })
  );
 */
export const getByIds = createSelector(selectEvaluationState, (state: State, props: { ids: number[] }) => {
  return props.ids.map((id) => state.entities[id]);
});

/**
 * returns an Evaluation with the given id
 * @example
 * evaluation$: EvaluationInterface = this.store.pipe(
    select(EvaluationQueries.getById, { id: 3 })
  );
 */
export const getById = createSelector(
  selectEvaluationState,
  (state: State, props: { id: number }) => state.entities[props.id]
);

export const isBookLoaded = (props: { bookId: number }) =>
  createSelector(selectEvaluationState, (state: State) => !!state.loadedForBook[props.bookId]);
